module.exports = __webpack_public_path__ + "img/empty-image-icon.14fb0e1d.svg";